import { saveAs } from "file-saver";
import moment from "moment";
import { processInWorker } from "../utils";
import {
  DATE_FORMAT_FOR_FILENAME,
  FILE_EXT_XLSX,
  WORKER_TOPIC_GET_BLOB,
} from "../constants";

export function getNextFileName({
  fileName,
  fileType,
  countOfFilesDownloaded,
  totalFilesToDownload,
}) {
  const nextFileNumber = countOfFilesDownloaded + 1;
  const fileCounter =
    fileType === FILE_EXT_XLSX
      ? `_${nextFileNumber}_of_${totalFilesToDownload}`
      : "";
  const dateTime = `_${moment().format(DATE_FORMAT_FOR_FILENAME)}`;
  return `${fileName}${fileCounter}${dateTime}.${fileType}`;
}

export default async function triggerFileDownload({
  abortController,
  exportStats,
  onTruncate,
  transforms,
}) {
  const {
    data,
    headers,
    fileType,
    itemsPerFile,
    isPartialDownload,
    totalItems,
    truncatedFields,
  } = exportStats;
  const dataLength = data?.length;
  const isAllDataDownloaded = isPartialDownload || dataLength >= totalItems;
  const comparisonOperator = isAllDataDownloaded ? "ceil" : "floor";
  const countOfFilesToDownload = Math[comparisonOperator](
    dataLength /
      (isPartialDownload ? Math.min(itemsPerFile, dataLength) : itemsPerFile)
  );

  if (countOfFilesToDownload < 1) {
    return;
  }

  while (exportStats.countOfFilesDownloaded < countOfFilesToDownload) {
    const start = exportStats.countOfFilesDownloaded * itemsPerFile;
    const end = Math.min(start + itemsPerFile, totalItems);

    const dataRows = data?.slice(start, end);
    const file = await processInWorker({
      messageData: {
        dataRows,
        headers: headers,
        fileType: fileType,
        transforms,
      },
      messageID: start,
      messageTopic: WORKER_TOPIC_GET_BLOB,
    });

    if (abortController?.signal?.aborted) {
      break;
    }

    saveAs(file, getNextFileName(exportStats));

    if (truncatedFields?.length > 0) {
      onTruncate?.(truncatedFields);
      exportStats.truncatedFields = [];
    }

    exportStats.countOfFilesDownloaded++;
  }
}
